import React, {useState} from "react";
import {Navigate, Outlet} from "react-router";

const NotLogInAuth = () => {
  const [userData] = useState(JSON.parse(localStorage.getItem("doctolikLoginInfo")));
  
  return !userData ? (
    <Outlet />
  ) : userData?.users?.type === "Doctor" ? (
    <Navigate to="/doctor/dashboard" />
  ) : userData?.users?.type === "Nurse" ? (
    <Navigate to="/nurse/appointments" />
  ) : userData?.users?.type === "Patient" ? (
    <Navigate to="/" />
  ) : (
    ""
  );
};

export default NotLogInAuth;
